import { render, staticRenderFns } from "./CommentTemplates.vue?vue&type=template&id=0b407891&"
import script from "./CommentTemplates.vue?vue&type=script&lang=js&"
export * from "./CommentTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports